import React from 'react';
import '../../../../styles/footer/contact/__text/contact__text.css';

function ContactText() {
    return (
      <div className='contact__text'>
        <h2 className='contact__text-title'>Contact</h2>
        <p className='contact__text-paragraph'>I would love to hear about your projects and how I could help. Please fill in the form, and I’ll get back to you as soon as possible.</p>
      </div>
    );
  }
  
  export default ContactText;